import axios from "axios";

export function isFerpaComplete() {
  return axios.post("/api/services/app/Form/IsFerpaComplete");
}

export function getFerpaFormByUser(userprofileId) {
  return axios.get("/api/services/app/Form/GetFerpaFormByUserProfileId", { params: { userprofileId } });
}
